const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};

const formatTime = date => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  return (
    [year, month, day].map(formatNumber).join("/") +
    " " +
    [hour, minute, second].map(formatNumber).join(":")
  );
};

const pad = (num, n) => {
  const a = "0000000000000000" + num;
  return a.substr(a.length - (n || 2));
};

const formatDate = (d, f) => {
  if (typeof d === "string" && /^\/Date\(\d+\)\/$/.test(d)) {
    d = new Function("return new " + d.replace(/\//g, ""))();
  } else if (typeof d === "number") {
    d = new Date(d);
  } else if (!d) {
    return "";
  }

  const y = d.getFullYear() + "",
    M = d.getMonth() + 1,
    D = d.getDate(),
    H = d.getHours(),
    m = d.getMinutes(),
    s = d.getSeconds(),
    mill = d.getMilliseconds() + "0000";
  return (f || "yyyy-MM-dd HH:mm:ss")
    .replace(/y{4}/i, y)
    .replace(/y{2}/i, y.substr(2, 2))
    .replace(/M{2}/, pad(M))
    .replace(/M/, M)
    .replace(/d{2,}/i, pad(D))
    .replace(/d/i, d)
    .replace(/H{2,}/i, pad(H))
    .replace(/H/i, H)
    .replace(/m{2,}/, pad(m))
    .replace(/m/, m)
    .replace(/s{2,}/, pad(s))
    .replace(/s/, s)
    .replace(/f+/, w => {
      return mill.substr(0, w.length);
    });
};

function getAgeOptionList() {
  const list = [];
  // 请选择
  list.push({
    age: 0,
    desc: "请选择年龄(必填)"
  });

  // 小于1岁（1-11月）
  let i = 0;
  for (i = 1; i <= 11; i++) {
    list.push({
      age: i,
      desc: i + "个月"
    });
  }
  // 1岁到100岁
  for (i = 1; i <= 100; i++) {
    list.push({
      age: i * 12,
      desc: i + "岁"
    });
  }
  return list;
}

//获取当天0点或24点时间戳
function currentDayStartOrEndTime(zero) {
  var timestamp = Date.parse(new Date());
  var date = new Date(timestamp);
  //获取年份
  var Y =date.getFullYear();
  //获取月份  
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  //获取当日日期 
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  if (zero)
    return Date.parse(Y+'/'+M+'/'+D+' '+'00:00:00');
  else 
    return Date.parse(Y+'/'+M+'/'+D+' '+'23:59:59');
};

module.exports = {
  formatTime,
  getAgeOptionList,
  formatDate,
  currentDayStartOrEndTime
};
